import React from 'react';

import useBuildInfoStore from '@/hooks/useBuildInfo';
import { calculateTime } from '@/utils';

import BuildDetailsCopyBadge from './components/BuildDetailsCopyBadge';
import BuildDetailsGrid, { BuildDetailsGridLabelValuePair } from './components/BuildDetailsGrid';

const BuildDetailsInfo: React.FC = () => {
  const { buildInfo } = useBuildInfoStore();

  return (
    <ul className="flex w-full flex-col gap-0.5">
      <li>
        <BuildDetailsGrid>
          <BuildDetailsGridLabelValuePair label="Env" value={buildInfo?.envId || ''} />
        </BuildDetailsGrid>
      </li>
      <li>
        <BuildDetailsGrid>
          <BuildDetailsGridLabelValuePair label="Host" value={window.location.hostname} />
        </BuildDetailsGrid>
      </li>
      <li>
        <BuildDetailsGrid>
          <BuildDetailsGridLabelValuePair
            label="Backend"
            value={
              <a href={buildInfo?.backendUrl} target="_blank" rel="noopener noreferrer">
                {buildInfo?.backendUrl || ''}
              </a>
            }
          />
        </BuildDetailsGrid>
      </li>
      <li>
        <BuildDetailsGrid>
          <BuildDetailsGridLabelValuePair
            label="API"
            value={
              <a href={buildInfo?.apiUrl} target="_blank" rel="noopener noreferrer">
                {buildInfo?.apiUrl || ''}
              </a>
            }
          />
        </BuildDetailsGrid>
      </li>
      <li>
        <BuildDetailsGrid>
          <BuildDetailsGridLabelValuePair
            label="Explorer"
            value={
              <a href={buildInfo?.explorerUrl} target="_blank" rel="noopener noreferrer">
                {buildInfo?.explorerUrl || ''}
              </a>
            }
          />
        </BuildDetailsGrid>
      </li>
      <li>
        <BuildDetailsGrid>
          <BuildDetailsGridLabelValuePair label="UI Version" value={buildInfo?.version || ''} />
        </BuildDetailsGrid>
      </li>
      <li>
        <BuildDetailsGrid>
          <BuildDetailsGridLabelValuePair
            label="UI Build"
            value={<BuildDetailsCopyBadge value={buildInfo?.build || ''} />}
          />
        </BuildDetailsGrid>
      </li>
      <li>
        <BuildDetailsGrid>
          <BuildDetailsGridLabelValuePair
            label="UI Deployment"
            value={buildInfo?.buildDate ? calculateTime(new Date(buildInfo.buildDate).getTime()).display : ''}
          />
        </BuildDetailsGrid>
      </li>
    </ul>
  );
};

export default BuildDetailsInfo;
